<script lang="ts">
  import Settings from '$lib/components/settings/Settings.svelte';
</script>

<svelte:head>
  <title>Coffee Pal - Settings</title>
</svelte:head>

<Settings />
